<template>
  <Section>
    <template v-slot:section-header>
      <h5 class="title">ถ่ายทอดสด</h5>
    </template>
    <template v-slot:section-body v-if="currentVideo">
      <div class="row">
        <div class="col-md-7">
					<p class="text-center">Live video</p>
				</div>
        <div class="col-md-5">
          <iframe :src="`https://chat-altv-develop-1.ndev.pw/embed/chatroom/?roomId=${videoId}&chatToken=${chatToken}`" width="100%" height="500" frameborder="0"/>
        </div>
      </div>
    </template>
  </Section>
</template>

<script>
import { mapState } from 'vuex';
import Section from '@/components/Section.vue';

export default {
  components: {
    Section,
  },
  data() {
    return {
      chatToken: '',
      videoId: '',
    };
  },
  created() {
    this.setChatRoom();
  },
  computed: {
    ...mapState({
      currentVideo: (state) => state.videoItem.currentVideo,
      user: (state) => state.user,
    }),
  },
  methods: {
    setChatRoom() {
      this.chatToken = this.user.chatToken;
      this.videoId = this.currentVideo.id;
    },
  },
};

</script>
<style lang="scss" scoped></style>
